<!--
  Authored.by.KWShin.2025.11.04.
-->
<template>
  <v-dialog v-model="userShow" persistent :max-width="conWidth">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ this.$t('alert.user.settings') }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeComp()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="form" v-if="showContent" class="mx-3 mb-3">
        <v-card flat class="dialog-form" :class="classContents">
          <v-row>
            <!-- eslint-disable-next-line prettier/prettier -->
            <v-col cols="3"><span class="label">{{ this.$t('alert.user.system') }}</span></v-col>
            <v-col cols="9"><v-text-field v-model="copyPropFormData.systemId" outlined dense disabled hide-details/></v-col>
            <template v-if="dscType === 'kpi' || dscType === 'healthyCheck' || dscType === 'userChange'">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.user.alertType') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="copyPropFormData.alertType" outlined dense disabled hide-details/></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.description') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="copyPropFormData.message" outlined dense disabled hide-details/></v-col>
            </template>
            <template v-else-if="dscType === 'abapDump'">
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.user.warningType') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="copyPropFormData.sapDataCode" outlined dense disabled hide-details/></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.user.abapId') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="copyPropFormData.alertCode" outlined dense disabled hide-details/></v-col>
            </template>
            <template v-else>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.user.warningType') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="copyPropFormData.sapDataCodeText" outlined dense disabled hide-details/></v-col>
              <!-- eslint-disable-next-line prettier/prettier -->
              <v-col cols="3"><span class="label">{{ this.$t('alert.monitor.programName') }}</span></v-col>
              <v-col cols="9"><v-text-field v-model="programName" outlined dense disabled hide-details/></v-col>
            </template>
          </v-row>
        </v-card>
      </v-form>
      <v-container>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-data-table
          :headers="headers" :items="copyAlertUsers" item-key="userId" :loading="loading"
          class="table-pd-s" height="200px"
          dense fixed-header disable-pagination hide-default-footer
        >
          <template v-slot:item.warningTray="{ item }">
            <v-checkbox v-model="item.warningTray" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningEmail="{ item }">
            <v-checkbox v-model="item.warningEmail" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningSms="{ item }">
            <v-checkbox v-model="item.warningSms" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.warningPush="{ item }">
            <v-checkbox v-model="item.warningPush" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalTray="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalTray" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalEmail="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalEmail" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalSms="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalSms" dense hide-details></v-checkbox>
          </template>
          <template v-slot:item.criticalPush="{ item }" v-if="isShowCritical">
            <v-checkbox v-model="item.criticalPush" dense hide-details></v-checkbox>
          </template>
        </v-data-table>
      </v-container>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn @click="save()" :loading="loading" small color="primary">{{ this.$t('common.save') }}</v-btn>
        <v-btn @click="closeComp()" small color="primary">{{ this.$t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { cloneDeep, pickBy, isBoolean, isEqual, differenceWith, values, forEach } from 'lodash';

export default {
  name: 'AlertUser',
  components: {},
  props: {
    userFormData: Object,
    uiType: {
      type: String,
      default: 'normal',
    },
    dscType: {
      type: String,
      default: 'kpi',
    },
  },
  data() {
    return {
      userShow: false,
      showContent: false,
      loading: true,
      copyPropFormData: {},
      copyAlertUsers: [],
    };
  },
  computed: {
    ...mapState('preference/alert', ['alertUsers', 'updateUsers']),
    programName() {
      if (this.copyPropFormData.programName.includes('::')) {
        return this.copyPropFormData.programName.split('::')[0];
      }
      return this.copyPropFormData.programName;
    },
    isShowCritical() {
      return this.uiType !== 'normal' ? true : false;
    },
    isDscType() {
      return this.dscType !== 'kpi' ? true : false;
    },
    conWidth() {
      return this.isShowCritical ? '680px' : '550px';
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
    headers() {
      const headers = [
        { text: this.$t('alert.user.id'), value: 'userId', width: '15%', sortable: false },
        { text: 'Tray', value: 'warningTray', align: 'center', sortable: false },
        { text: 'E-mail', value: 'warningEmail', align: 'center', sortable: false },
        { text: 'SMS', value: 'warningSms', align: 'center', sortable: false },
        { text: 'Push', value: 'warningPush', align: 'center', sortable: false },
      ];
      const apiHeaders = [
        { text: this.$t('alert.user.criticalTray'), value: 'criticalTray', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalEmail'), value: 'criticalEmail', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalSms'), value: 'criticalSms', align: 'center', sortable: false },
        { text: this.$t('alert.user.criticalPush'), value: 'criticalPush', align: 'center', sortable: false },
      ];
      if (this.isShowCritical) return [...headers, ...apiHeaders];
      return headers;
    },
  },
  watch: {
    copyPropFormData() {
      this.showContent = true;
      this.fetchAlertUsers();
    },
    alertUsers(val) {
      this.copyAlertUsers = cloneDeep(val);
    },
    copyAlertUsers() {
      this.loading = false;
    },
    userShow(val) {
      if (val) this.copydata();
    },
    updateUsers(val) {
      if (val === 'success') this.closeComp();
    },
  },
  methods: {
    async copydata() {
      this.copyPropFormData = await { ...this.userFormData };
    },
    resetDatas() {
      this.copyPropFormData = {};
      this.copyAlertUsers = [];
    },
    fetchAlertUsers() {
      const params = {
        systemId: this.copyPropFormData.systemId,
        sapDataCode: this.copyPropFormData.sapDataCode,
        alertCode: this.copyPropFormData.alertCode,
      };
      this.$store.dispatch('preference/alert/alertUsers', params);
    },
    closeComp() {
      this.userShow = false;
    },
    allCheckValue(val = []) {
      return values(pickBy(val, isBoolean)).every(el => el === false);
    },
    makeParams(differences) {
      let paramData = [];
      forEach(differences, value => {
        let isAllFalse = this.allCheckValue(value);
        if (value.status !== 'NOTEXISTED') {
          value.status = isAllFalse ? 'DELETED' : 'UPDATED';
        } else {
          value.status = isAllFalse ? 'NOTEXISTED' : 'INSERTED';
        }
        paramData.push(value);
      });
      this.$store.dispatch('preference/alert/updateAlertUsers', paramData);
    },
    save() {
      const differences = differenceWith(this.copyAlertUsers, this.alertUsers, isEqual);
      if (!differences.length) {
        this.closeComp();
      } else {
        this.makeParams(differences);
      }
    },
  },
};
</script>

<style scoped>
.label {
  padding-left: 10px;
}
.v-text-field {
  width: 100%;
}
</style>
